export function hasVerifiedCardRefund(order) {
  return order?.payment_method === "card" && order.status === "refunded"
    && (order.payment_info?.status || order.payment_status) === "cancelled";
}

export function blocksManualCardCancellation(order, status) {
  return order?.payment_method === "card" && ["cancelled", "refunded"].includes(status);
}

export function getCardRefundState(order) {
  const refundStatus = order?.refund_info?.status;
  const uncertain = ["sending", "unknown"].includes(refundStatus);
  const payment = order?.payment_info || {};
  const eligible = order?.payment_method === "card"
    && ["confirmed", "processing"].includes(order.status)
    && payment.status === "approved" && Boolean(payment.tno)
    && !order.shipped_at && !order.tracking_number;
  return {
    completed: hasVerifiedCardRefund(order),
    uncertain,
    allowed: !uncertain && eligible && order.can_refund !== false,
    status: refundStatus,
  };
}

export function refundResponseConfirmed(data) {
  return data?.success === true && data.status === "refunded"
    && data.payment_status === "cancelled" && data.refund_status === "completed";
}
